import styled from "styled-components";
import { Tile } from "@carbon/react";

export const RouteContainer = styled.div`
  color: #f4f4f4;
  margin-bottom: 0.2rem;
  height: 100%;   /* so the card stretches with the row cell */
`;

/* key: middle column uses minmax(0, 1fr) so it can shrink */
export const RouteGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 200px; /* Route | Destination */
  gap: 0.1rem;
  align-items: start;
  height: 100%;
`;

export const LocationColumn = styled.div`
  text-align: center;
  height: 100%;
`;

export const LocationTile = styled(Tile)`
  background: #262626;
  border: 1px solid #393939;
  color: #f4f4f4;
  padding: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .location-title {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 4px;
  }

  .location-subtitle {
    font-size: 12px;
    color: #a8a8a8;
  }
`;

/* key: allow inner overflow; don't let this grid cell force page scroll */
export const RoutePathContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #393939;
  align-items: stretch;
  min-width: 0;
  overflow: visible;
  height: 100%;
`;

export const RouteLabel = styled.div`
  text-align: center;
  font-size: 12px;
  color: #a8a8a8;
  margin: 8px 0;
`;

/* the ONLY scrollable area for each row */
export const TrucksViewport = styled.div`
  width: 100%;
  overflow: visible;
`;

/* inner lane that stays in one line */
export const TrucksLane = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  padding: 1rem 1rem 1rem 0.75rem;
  white-space: normal;
  justify-content: flex-start;
`;

/* items don’t shrink; each row scrolls independently */
export const TruckItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex: 0 0 auto;
`;

export const TruckBadge = styled.div`
  background: ${(p) => p.statusColor};
  color: white;
  padding: 4px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
`;

export const TruckPatent = styled.div`
  font-size: 11px;
  color: #f4f4f4;
  font-weight: 500;
`;

export const TruckIcon = styled.div`
  width: 16px;
  height: 16px;
  background: ${(p) => p.statusColor};
  border-radius: 2px;
  position: relative;

  &::after {
    content: "🚛";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 10px;
  }
`;

export const RouteStats = styled.div`
  text-align: center;
  font-size: 12px;
  color: #a8a8a8;
  margin-top: 8px;
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
  color: #a8a8a8;
`;

export const EmptyState = styled.div`
  color: #6f6f6f;
  font-size: 12px;
  text-align: center;
  font-style: italic;
`;
